import * as types from '../actions/loginactionstypes'
const initialState = {
    isLoginVisible: false,
    loginMessage:'',    
    userName: null,
    password: null,
    resetEmail:null,
    userkey: null,
    newUserPassword:null,
    confirmNewUserPassword:null,
    forgotPasswordMessage:null,
    userNametoReset:null,
}
export default function loginReducer(state = initialState, action){
    switch(action.type){
    
        case types.UPDATE_LOGIN_STATE:
            let {name, value} = action.payload
            return {
                ...state,
                    [name]: value
            }
        case types.SET_LOGIN_MESSAGE :
            return {
                ...state, 
                loginMessage: action.payload,
            }
            case types.RESET_LOGIN_STATE :
                return {
                    ...state, 
                    resetEmail:null,
                    userkey: null,
                    newUserPassword:null,
                    confirmNewUserPassword:null,
                }
        
        default:
        return state;
    }
}



